var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',_vm._b({scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('b-icon',{attrs:{"icon":"gear"}}),_vm._v(" "+_vm._s(_vm.text)+"\n    ")]},proxy:true}])},'b-dropdown',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }